<template>
    <div>
        <img src="/assets/images/loading.svg" alt="Loading Clash of Clans" width="70"/>
    </div>
</template>
<script>
/* eslint-disable */
export default {
    name: "Loading",
}
</script>
<style>
    
</style>